class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.addBtn = this.querySelector('.cart-upsell__add-btn');
    this.variantSelect = this.querySelector('.cart-upsell__variant-select');
    this.addBtn?.addEventListener('click', () => this.handleAdd());
    this.variantSelect?.addEventListener('change', (e) => {
      e.stopPropagation();
      this.handleVariantChange(e);
    });
  }

  handleVariantChange(e) {
    const option = e.target.selectedOptions[0];
    if (!option) return;

    const variantId = parseInt(option.value);
    const variants = JSON.parse(this.dataset.variants || '[]');
    const variant = variants.find((v) => v.id === variantId);

    const img = this.querySelector('.cart-upsell__product-image');
    if (img && variant?.featured_image) {
      img.src = variant.featured_image.src + '&width=160';
      img.alt = variant.featured_image.alt || '';
    }

    const priceEl = this.querySelector('.cart-upsell__product-price');
    if (priceEl && option.dataset.price) {
      if (option.dataset.comparePrice) {
        priceEl.innerHTML =
          `<span class="cart-upsell__product-sale-price">${option.dataset.price}</span>` +
          `<span class="cart-upsell__product-compare-price">${option.dataset.comparePrice}</span>`;
      } else {
        priceEl.innerHTML = `<span class="cart-upsell__product-regular-price">${option.dataset.price}</span>`;
      }
    }
  }

  async handleAdd() {
    const variantId = this.variantSelect
      ? parseInt(this.variantSelect.value)
      : parseInt(this.dataset.variantId);

    if (!variantId) return;

    this.addBtn.disabled = true;

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!addRes.ok) throw new Error('Add to cart failed');

      // Re-render the cart drawer section
      const sectionRes = await fetch('/?sections=cart-drawer');
      const data = await sectionRes.json();

      if (data['cart-drawer']) {
        const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const newDrawer = doc.querySelector('#CartDrawer');
        const currentDrawer = document.querySelector('#CartDrawer');
        const currentDrawerEl = document.querySelector('cart-drawer'); 
        newDrawer?.closest('cart-drawer')?.classList.contains('is-empty') ? currentDrawerEl?.classList.add('is-empty') : currentDrawerEl?.classList.remove('is-empty');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
    } catch (err) {
      console.error('[CartUpsell]', err);
      this.addBtn.disabled = false;
    }
  }
}

customElements.define('cart-upsell', CartUpsell);

class CartCollection extends HTMLElement {
  async connectedCallback() {
    await CartCollection.loadSwiper();
    this.initSwiper();
    this.bindButtons();
  }

  disconnectedCallback() {
    this.swiperInstance?.destroy(true, true);
  }

  static loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (CartCollection._loading) return CartCollection._loading;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(link);

    CartCollection._loading = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = resolve;
      document.head.appendChild(script);
    });
    return CartCollection._loading;
  }

  initSwiper() {
    const swiperEl = this.querySelector('.cart-collection__swiper');
    if (!swiperEl || !window.Swiper) return;
    this.swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 8,
      grabCursor: true,
      freeMode: true,
       breakpoints: {
        768: {
          slidesPerView: 3, // change to your desired value
        },
      },
    });
  }

  bindButtons() {
    this.querySelectorAll('.cart-collection__card-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleAdd(btn);
      });
    });
  }

  async handleAdd(btn) {
    const variantId = parseInt(btn.dataset.variantId);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!addRes.ok) throw new Error('Add to cart failed');

      const sectionRes = await fetch('/?sections=cart-drawer');
      const data = await sectionRes.json();

      if (data['cart-drawer']) {
        const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const newDrawer = doc.querySelector('#CartDrawer');
        const currentDrawer = document.querySelector('#CartDrawer');
        const currentDrawerEl = document.querySelector('cart-drawer'); 
        newDrawer?.closest('cart-drawer')?.classList.contains('is-empty') ? currentDrawerEl?.classList.add('is-empty') : currentDrawerEl?.classList.remove('is-empty');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
    } catch (err) {
      console.error('[CartCollection]', err);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = originalText;
    }
  }
}

customElements.define('cart-collection', CartCollection);
